import { Buffer } from 'buffer';

export const downloadCSV = (csv: string, fileName: string) => {
  const csvFile = new Blob([csv], { type: 'text/csv' });
  downloadFile({ url: csvFile, fileName });
};

export const downloadFile = ({
  url,
  fileName
}: {
  url: Blob;
  fileName: string;
}) => {
  const href = window.URL.createObjectURL(url);
  const link = document.createElement('a');
  link.href = href;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();

  window.URL.revokeObjectURL(href);
  document.body.removeChild(link);
};

export const getDownloadByContentType = (contentType: string) => {
  switch (contentType) {
    case 'application/pdf':
      return downloadPdfFile;
    case 'text/csv':
      return downloadCsvFile;
    case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
      return downloadDocxFile;
    case 'application/zip':
      return downloadZipFile;
    default:
      return null;
  }
};

export const downloadPdfFile = (data: string, file: string): void => {
  const blob = new Blob([Buffer.from(data, 'base64')], {
    type: 'application/pdf'
  });
  const fileName = `${file}.pdf`;
  downloadFile({ url: blob, fileName });
};

export const downloadZipFile = (data: string, file: string): void => {
  const blob = new Blob([Buffer.from(data, 'base64')], {
    type: 'application/zip'
  });
  const fileName = `${file}.zip`;
  downloadFile({ url: blob, fileName });
};

export const downloadDocxFile = (data: string, file: string): void => {
  const blob = new Blob([Buffer.from(data, 'base64')], {
    type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
  });
  const fileName = `${file}.docx`;
  downloadFile({ url: blob, fileName });
};

export const downloadCsvFile = (data: string, file: string): void => {
  const blob = new Blob([Buffer.from(data, 'base64')], {
    type: 'text/csv'
  });
  const fileName = `${file}.csv`;
  downloadFile({ url: blob, fileName });
};
